import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { NextUIProvider } from "@nextui-org/react";
import ReloadPrompt from "./component/reloadPrompt";
import iosPWASplash from "ios-pwa-splash";
import splashIcon from "/pwa-512x512.png";
import App from "./LazyApp";
import { Toaster } from "react-hot-toast";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

dayjs.extend(relativeTime);
dayjs.locale("zh-cn");

if (import.meta.env.MODE === "production") {
  Sentry.init({
    dsn: "https://7bcb5c0f7700de8898f6f76b156a6cfe@o1412794.ingest.us.sentry.io/4508346235027456",
    release: `pinnacle-web@${import.meta.env.VITE_APP_GITHUB_SHA}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,
      }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.httpClientIntegration(),
    ],
    tracesSampleRate: 0.01,
    tracePropagationTargets: [
      /^https?:\/\/[^/]+?\.mjclouds\.com(\/|$)/,
      "localhost",
    ],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <NextUIProvider>
      <App />
      <ReloadPrompt />
      <Toaster
        toastOptions={{
          success: {
            iconTheme: {
              primary: "#faeed6",
              secondary: "#af782b",
            },
          },
          error: {
            iconTheme: {
              primary: "#faeed6",
              secondary: "#af782b",
            },
          },
        }}
      />
    </NextUIProvider>
  </React.StrictMode>,
);

iosPWASplash(splashIcon, "#FFFFFF");
